import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { saveWorkflow } from "actions/workflows";
import Input from "components/Elements/Input";

const NodePropertiesModal = NiceModal.create(({ node_id, workflow = {} }) => {
  console.log("!!! NODE_ID: ", node_id);
  if (!node_id) return <div>Loading Node Properties...</div>;
  const node = workflow.graph.nodes[node_id];
  const dispatch = useDispatch();
  const [values, setValues] = useState({});
  const modal = useModal();

  useEffect(() => {
    const u = {};
    for (let key in node.properties) {
      u[key] = node.properties[key].value;
    }
    setValues(u);
  }, [node]);

  const hide = (e) => {
    e.stopPropagation();
    modal.remove();
  };

  const handleChange = ({ target }) => {
    const u = { ...values };
    u[target.name] = target.value;
    setValues(u);
  };

  const saveNodeProperties = () => {
    for (let key in values) {
      workflow.graph.nodes[node_id].properties[key].value = values[key];
    }
    dispatch(saveWorkflow(workflow));
  };

  const renderNodeProperties = () => {
    const properties = node.properties;
    const propertyFields = [];
    Object.keys(properties).forEach((name) => {
      const property = properties[name];
      if (
        property.type === "string" ||
        property.type === "text" ||
        property.type === "textarea"
      ) {
        propertyFields.push(
          <div key={name} className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor={name}
            >
              {name}
            </label>
            <Input
              type={property.type}
              label={name}
              placeholder={property.description}
              name={name}
              value={values[name] || ""}
              onChange={handleChange}
            />
          </div>
        );
      } else if (property.type === "int") {
        propertyFields.push(
          <div key={name} className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor={name}
            >
              {name}
            </label>
            <Input
              type="number"
              step={1}
              label={name}
              placeholder={property.description}
              name={name}
              value={values[name] || ""}
              onChange={handleChange}
            />
          </div>
        );
      }
    });

    return propertyFields;
  };

  return (
    <>
      <div className="w-6/12 force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                {node
                  ? `${node.name} Node Properties`
                  : "Loading Node Properties..."}
              </h3>
            </div>
            <div className="relative p-6 flex-auto ">
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                {renderNodeProperties(node)}
              </div>
            </div>

            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={hide}
              >
                Close
              </button>
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={() => saveNodeProperties()}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

export default NodePropertiesModal;
